var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 6.10002C12.6263 3.68001 10.373 2.28668 7.99967 2.28668C6.81301 2.28668 5.65967 2.63335 4.60634 3.28002C3.55301 3.93335 2.60634 4.88668 1.83301 6.10002C1.16634 7.14668 1.16634 8.84668 1.83301 9.89335C3.37301 12.32 5.62634 13.7067 7.99967 13.7067C9.18634 13.7067 10.3397 13.36 11.393 12.7133C12.4463 12.06 13.393 11.1067 14.1663 9.89335C14.833 8.85335 14.833 7.14668 14.1663 6.10002ZM7.99967 10.6933C6.50634 10.6933 5.30634 9.48668 5.30634 8.00002C5.30634 6.51335 6.50634 5.30668 7.99967 5.30668C9.49301 5.30668 10.693 6.51335 10.693 8.00002C10.693 9.48668 9.49301 10.6933 7.99967 10.6933Z",
    fill: "#A0A0AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99961 6.09332C6.95294 6.09332 6.09961 6.94666 6.09961 7.99999C6.09961 9.04666 6.95294 9.89999 7.99961 9.89999C9.04628 9.89999 9.90628 9.04666 9.90628 7.99999C9.90628 6.95332 9.04628 6.09332 7.99961 6.09332Z",
    fill: "#A0A0AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6c30fdda8a0a80c440e685d4274f24c8.svg";
export { ForwardRef as ReactComponent };